// src/pages/HistoryTopicPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Crystal from './crystal.jsx';
import overlayImage from '../assets/croppedscroll.png';
import axios from 'axios';
import './TopicPage.css'
import api from '../api.js'



function TopicPage({
  topicKey,
  title,
  backgroundImage,
  scrollLabels,
  startRoute,
  /** where the Back button should go (default: /history2) */
  backRoute = "/history2",
  /** button text (default: "⬅ Back") */
  backLabel = "⬅ Back",
  /** extra className or inline style if you want to style the button */
  backButtonClassName = "journey-button",
  backButtonStyle = {},
}) {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(null);
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    api.get(`${process.env.REACT_APP_API_URL}/api/progress/`, {
      params: { sub_topic: topicKey },
          withCredentials: false,                          // <-- no cookies
          headers: { Authorization: `Bearer ${token}` }, 
    }).then(res => setProgress(res.data))
      .catch(err => console.error('Progress fetch error:', err));
  }, [topicKey]);

  return (
    <div style={{ backgroundColor: '#000', height: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif', color: 'white' }}>
      {/* Top Bar */}
      <div className='medieval-text' style={{ height: '5vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
        
      </div>

      {/* Main Background Area */}
<div className="topic-background-wrapper">
  <img src={backgroundImage} alt="Background" className="topic-background-image" />




<div className="scroll-labels-wrapper">
  {scrollLabels.map((label, idx) => (
    <div
      key={idx}
      className="scroll-label"
      onMouseEnter={(e) => {
        const span = e.currentTarget.querySelector('span');
        if (span) span.style.textShadow = '0 0 10px #faf9f6ff';
      }}
      onMouseLeave={(e) => {
        const span = e.currentTarget.querySelector('span');
        if (span) span.style.textShadow = 'none';
      }}
    >
      <span className="medieval-text">{label}</span>
    </div>
  ))}
</div>

        {/* Start Button */}
    <div className="start-button-wrapper">
      <button className="quiz-button" onClick={() => navigate(startRoute)}>Start</button>
    </div>




        {/* Progress */}
<div className="progress-indicator">
  <span className="medieval-text">{progress ? `${progress.percent_correct}%` : '...'}</span><br />
  <span className="medieval-text progress-subtext">Completed</span>
</div>
        
        {/* Floating Scroll (center top) */}
          <img
            src={overlayImage}
            alt="Floating Scroll"
            className="floating-scroll"
          />


          {/* Top-Right Corner Scroll */}
          <img
            src={overlayImage}
            alt="Corner Scroll"
            className="corner-scroll"
          />


<div className="crystals-container">
  {[33.33, 66.66, 100].map((threshold, i) => (
    <div key={i} className="crystal-wrapper">
      <Crystal
        size={34}
        locked={!(progress && progress.percent_correct >= threshold)}
      />
    </div>
  ))}
</div>








<div className="back-button-wrapper-bottom">
  <button
    className={backButtonClassName}
    style={backButtonStyle}
    onClick={() => navigate(backRoute)}
  >
    {backLabel}
  </button>
</div>


      </div>

      {/* Bottom Bar */}
      <div style={{ height: '7vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>
        
      </div>
    </div>
  );
}

export default TopicPage;
